import React, { useMemo } from 'react';
import SectionPliable from '../../../composants/SectionPliable/SectionPliable';
import { ContratRef } from '../types';
import { buildPreparationRecap, PreparationOperation } from '../domain/preparation';
import './OperationPreparationBC.css';

// Section « Préparation du Bon de Commande » : recap en lecture seule, decalque du MS
// (OperationMarchePreparation). Purement presentationnel — aucun fetch, tout vient du payload.
//
// `SectionPliable` et non l'accordeon du MS : c'est le conteneur pliable du BC, deja utilise par
// toutes les autres sections de ces onglets. Reprendre celui du MS aurait importe un composant
// cross-module pour un rendu identique.

// Rendu par les DEUX faces du BC (acheteur SuiviOperationBCV2, prestataire SuiviDeCommandeBCV2) :
// d'ou un `titulaire` en entree plutot qu'un rang. L'acheteur passe la commande du rang consulte, le
// prestataire passe la sienne — il n'a pas la liste des commandes de l'operation.
interface OperationPreparationBCProps {
  operation: PreparationOperation;
  /** Commande du titulaire a decrire : elle porte son contrat (numero + entite). */
  titulaire?: { contrat?: ContratRef };
}

const OperationPreparationBC: React.FC<OperationPreparationBCProps> = ({ operation, titulaire }) => {
  const fields = useMemo(() => buildPreparationRecap(operation, titulaire), [operation, titulaire]);

  return (
    <SectionPliable title="Préparation du Bon de Commande" defaultOpen>
      <div className="section-content">
        <div className="bc-recap-grid">
          {fields.map((field) => (
            <div className="bc-recap-field" key={field.label}>
              <span className="bc-recap-label">{field.label}</span>
              <span className="bc-recap-value">{field.value}</span>
            </div>
          ))}
        </div>
      </div>
    </SectionPliable>
  );
};

export default OperationPreparationBC;
